import { render, staticRenderFns } from "./ContactSearchLocationCard.vue?vue&type=template&id=52e1cd6a&"
import script from "./ContactSearchLocationCard.vue?vue&type=script&lang=js&"
export * from "./ContactSearchLocationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports